import type { BetaDashboardTask } from '@/types/beta-dashboard'

export const calculateBetaProgress = (tasks: BetaDashboardTask[]) => {
    const applicableTasks = tasks.filter((task) => (
        task.mandatory
        && task.state !== 'dismissed'
    ))

    if (applicableTasks.length === 0) {
        return 100
    }

    if (applicableTasks.some((task) => (
        task.state === 'unknown'
        || task.state === 'unsupported'
    ))) {
        return null
    }

    const completeTasks = applicableTasks.filter((task) => task.state === 'complete').length

    return Math.round((completeTasks / applicableTasks.length) * 100)
}
